"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _loading = require("@/mixins/loading/loading");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _elementUi = require("element-ui");

var _countdown = _interopRequireDefault(require("@/components/countdown/countdown.vue"));

var _moment = _interopRequireDefault(require("moment"));

var _report = require("@/api/report.api");

var _permission = require("@/mixins/permission/permission");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRLatenessDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRLatenessDashboardComponent, _Mixins);

  var _super = _createSuper(MRLatenessDashboardComponent);

  function MRLatenessDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRLatenessDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.maxDays = 30;
    _this.dateRange = [(0, _moment.default)(new Date()).format('YYYY-MM-DD'), (0, _moment.default)(new Date()).format('YYYY-MM-DD')];
    _this.reportAPI = null;
    _this.reportData = [];
    _this.selectedProjectCodes = [];
    _this.tableHeight = 400;
    _this.oldTableHeight = 400;
    _this.refreshTime = 30; // seconds

    return _this;
  }

  (0, _createClass2.default)(MRLatenessDashboardComponent, [{
    key: "onFSChanges",
    value: function onFSChanges(newVal) {
      if (newVal) {
        this.tableHeight = window.innerHeight - 110;
      } else {
        this.tableHeight = this.oldTableHeight;
      }
    }
  }, {
    key: "containerStyles",
    get: function get() {
      return {
        height: !this.$isFullscreen ? 'calc(100vh - 60px)' : '100%'
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {}
  }, {
    key: "created",
    value: function created() {
      this.refreshTime = parseInt(this.helper.get(this.$userSetting, 'default14', 30), 10);

      if (!this.reportAPI) {
        this.reportAPI = new _report.ReportAPI({
          customerKey: this.$userInformation.customerKey || ''
        });
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var containerEl, countdownEl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerEl = this.helper.get(this.$refs, 'container', null);

                if (containerEl) {
                  this.tableHeight = containerEl.clientHeight - 100;
                  this.oldTableHeight = containerEl.clientHeight - 100;
                }

                countdownEl = this.helper.get(this.$refs, 'countdown', null);

                if (!countdownEl) {
                  _context.next = 7;
                  break;
                }

                _context.next = 6;
                return this.getData('data');

              case 6:
                countdownEl.startTimer();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }() // hacked should use socket

  }, {
    key: "handleCountdownZero",
    value: function () {
      var _handleCountdownZero = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getData('data');

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCountdownZero() {
        return _handleCountdownZero.apply(this, arguments);
      }

      return handleCountdownZero;
    }()
  }, {
    key: "isValidDateRange",
    value: function isValidDateRange(dateRange) {
      var startDate = (0, _moment.default)(dateRange[0]);
      var endDate = (0, _moment.default)(dateRange[1]);

      var duration = _moment.default.duration(endDate.diff(startDate)).asDays();

      if (duration > this.maxDays) {
        var message = {
          title: this.$i18n.t('general.queryExceed1Month'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        return false;
      }

      return true;
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
        var _this2 = this;

        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isValidDateRange(this.dateRange)) {
                  _context3.next = 10;
                  break;
                }

                this.loading = true;
                /*const res = await this.reportAPI.getMRLatenessReport({ type: type }, {
                  startDate: this.dateRange[0],
                  endDate: this.dateRange[1],
                  projectCode: this.selectedProjectCodes,
                  blockProjectCode: this.$userInformation.blockedProjects || []
                });*/

                _context3.next = 4;
                return this.reportAPI.getMRLatenessDashboard({
                  startDate: this.dateRange[0],
                  endDate: this.dateRange[1]
                });

              case 4:
                res = _context3.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", null);

              case 7:
                if (type === 'data') {
                  this.reportData = res.data.reduce(function (acc, val) {
                    val.routes.forEach(function (route) {
                      acc.push(_objectSpread(_objectSpread({}, route), {}, {
                        plateNumber: val.plateNumber
                      }));
                    });
                    return acc;
                  }, []).filter(function (route) {
                    return route.waypointType === 'P' || route.waypointType === 'D' ? _this2.isETAEarlyLate(route) : _this2.isEndTimeEarlyLate(route);
                  });
                  this.logger.info('Lateness Dashboard', res.data, this.reportData);
                }

                if (type === 'xls') {
                  window.location.href = res.data;
                }

                this.loading = false;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getData(_x) {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "isETAEarlyLate",
    value: function isETAEarlyLate(route) {
      return !this.helper.isUndefined(route) && route.actualData.runningTimeDifference >= 1800;
    }
  }, {
    key: "isEndTimeEarlyLate",
    value: function isEndTimeEarlyLate(route) {
      return !this.helper.isUndefined(route) && route.actualData.endRunningTimeDifference >= 900;
    }
  }, {
    key: "isEstimateReasonLate",
    value: function isEstimateReasonLate(route) {
      return !(this.helper.isUndefined(route) || route.actualData.estimateReason === 'on time');
    }
  }, {
    key: "isEndReasonLate",
    value: function isEndReasonLate(route) {
      return !(this.helper.isUndefined(route) || route.actualData.endReason === 'on time');
    }
  }, {
    key: "tableRowClassName",
    value: function tableRowClassName(_ref) {
      var row = _ref.row;

      if (this.helper.isUndefined(row) || this.helper.isUndefined(row.actualData)) {
        return '';
      }

      if (row.actualData.runningTimeDifference === 0 || row.actualData.endRunningTimeDifference === 0) {
        return '';
      }

      var waypointType = row.waypointType;
      var estimateDuration = row.actualData.runningTimeDifference;
      var endDuration = row.actualData.endRunningTimeDifference;
      var pFloor = 60;
      var pCeil = 900;
      var dFloor = 60;
      var dCeil = 1800;

      if (waypointType === 'P') {
        if (estimateDuration >= pFloor && estimateDuration <= pCeil || endDuration >= pFloor && endDuration <= pCeil) {
          return 'warning-row';
        } else if (estimateDuration > pCeil) {
          return 'error-row';
        } else {
          return '';
        }
      } else if (waypointType === 'D') {
        if (estimateDuration >= dFloor && estimateDuration <= dCeil || endDuration >= dFloor && endDuration <= dCeil) {
          return 'warning-row';
        } else if (estimateDuration > dCeil) {
          return 'error-row';
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
  }]);
  return MRLatenessDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MRLatenessDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MRLatenessDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MRLatenessDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRLatenessDashboardComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('projectCodes', {
  namespace: 'common'
})], MRLatenessDashboardComponent.prototype, "$projectCodes", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isFullscreen')], MRLatenessDashboardComponent.prototype, "onFSChanges", null);
MRLatenessDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRLatenessDashboardComponent',
  components: {
    'countdown': _countdown.default,
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn
  }
})], MRLatenessDashboardComponent);
var _default = MRLatenessDashboardComponent;
exports.default = _default;